<template>
  <div class="mb-3 card card-sm card-choice">
    <div class="card-header">
      {{ title }}
      <template v-if="choice">
        <button
          class="ms-auto btn btn-sm btn-success"
          @click.prevent="emit('change-choice')"
        >
          Change
        </button>
        <button
          class="ms-2 btn btn-sm btn-danger"
          @click.prevent="emit('remove-choice')"
        >
          Remove
        </button>
      </template>
    </div>
    <div
      v-if="choice"
      class="card-body"
    >
      <div
        v-if="hasErrorMessages"
        class="alert alert-danger"
      >
        <h4>Validation errors</h4>
        <hr>
        <ul>
          <li
            v-for="(message, messageIdx) of choice.errorMessages"
            :key="messageIdx"
          >
            {{ message }}
          </li>
        </ul>
      </div>
      <div class="row">
        <dl class="col col-4">
          <dt>Institution</dt>
          <dd>{{ choice.institutionName }}</dd>
        </dl>
        <dl class="col col-4">
          <dt>Period</dt>
          <dd>{{ choice.activityPlacePeriodDate }}</dd>
        </dl>
        <dl class="col col-4">
          <dt>Language</dt>
          <dd>{{ choice.activityPlacePeriodLanguage }}</dd>
        </dl>
      </div>
      <hr>
      <div>
        <label class="form-label mb-2">Please indicate any special interest (ie. specialisation)</label>
        <input
          v-model="choice.specialInterest"
          class="form-control form-control-sm"
          type="text"
        >
      </div>
    </div>
    <div
      v-else
      class="card-body m-4 text-center"
    >
      <button
        class="btn btn-info"
        type="button"
        @click.prevent="emit('change-choice')"
      >
        Select study visit
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

import type { OspeStudyVisitChoice } from '../../ospe-types'

defineProps({
  title: { default: '', type: String },
})

const choice = defineModel<OspeStudyVisitChoice | null>('choice', { required: true })

const emit = defineEmits<{
  'change-choice': []
  'remove-choice': []
}>()

const hasErrorMessages = computed((): boolean => {
  return Array.isArray(choice.value?.errorMessages) && choice.value.errorMessages.length > 0
})
</script>
